import ForceGraph2D from 'react-force-graph-2d';
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { forceCollide } from 'd3-force-3d';
import GraphNode from './GraphNode';
import { useListFocus } from '../Context/ListFocus';
import { IconButton, Tooltip } from '@mui/joy';
import { Close } from '@mui/icons-material';




export default function MainGraph() {
    const parentRef = useRef(null);
    const dispatch = useDispatch();
    const finalStateData = useSelector(state => state.finalState.finalStateData);
    const treeMask = useSelector(state => state.treeMask);  // A mask where we find the resonance names in case a specific chain is selected for debugging


    const ForceTree = ({ data }) => {
        const fgRef = useRef();  
        const { focusItem } = useListFocus();
        useEffect(() => {
          // add collision force
          fgRef.current.d3Force('collision', forceCollide(node => 25));
        }, []);
  
        return <ForceGraph2D
          ref={fgRef}
          graphData={data}
          dagMode={'lr'}
          dagLevelDistance={150}
          backgroundColor="#ffffffff"
          linkColor={() => 'rgba(0, 0, 0, 1)'}
          nodeRelSize={1}
          nodeId="id"
          nodeVal={node => 300 / (node.level + 1)}
          nodeLabel="name"
          nodeAutoColorBy="level"
          linkDirectionalParticles={0}
          linkDirectionalParticleWidth={2}
          d3VelocityDecay={0.3}
          d3AlphaDecay={0.8}
          enableZoomInteraction={true}
          cooldownTicks={100}
          onNodeClick={(node) => {
            focusItem(node.id);
          }}
          nodeCanvasObject={(node, ctx, globalScale) => GraphNode(node, ctx, globalScale)}
        />;
      };
    const graph = useSelector((state) => state.mainGraph);
    if (!graph.visible || !graph.tuple) {
        return null;
    }
    
    const build_nodes = (tuple, level = 0, source = null) => {
        const nodes = [];
        if (level === 0){
          nodes.push(source);
        }
        
        for (let i = 0; i < tuple.length; i++) {
          const internalNodes = tuple[i].length ? tuple[i].flat(Infinity) : [tuple[i]];
          var name = internalNodes.sort().map(n => finalStateData[n].name).join(" ");
          var check = true;             
          const flatTopology = Array.isArray(tuple[i]) ? tuple[i].flat(Infinity).sort() : tuple[i];
          const topologyString = JSON.stringify(flatTopology);
          if (treeMask && treeMask.hasOwnProperty(JSON.stringify(tuple[i]))){
            const res = treeMask[JSON.stringify(tuple[i])]
            name = res.name + "    J(P)=" + res.spin + "(" + res.parity + ")";
            check = res.check;
          }

          const node = { id: topologyString, source: source.id, name: name, val: level, level: Array.isArray(tuple[i]) ? 1 : 2, tuple: tuple[i] }
          nodes.push(node);
          if (Array.isArray(tuple[i])) {
            nodes.push(...build_nodes(tuple[i], level+1, node));
          }
        }
        return nodes;
    };
    const nodes = build_nodes(graph.tuple, 0, {id: '0', name: "0", val: 0, level: 0, tuple:null});
    const links = nodes.map((node, i) => ({ source: node.source, target: node.id })).slice(1);
    const data = {
        nodes,
        links
    }
    

  return (
      <div
        style={{
          position: 'relative',
          flexGrow: 1,
          overflow: 'hidden',
          display: 'flex',
          maxHeight: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Tooltip title="Close graph">
          <IconButton
            size="sm"
            variant="soft"
            color="neutral"
            onClick={() => dispatch({ type: 'HIDE_MAIN_GRAPH' })}
            style={{ position: 'absolute', top: 8, right: 8, zIndex: 10 }}
          >
            <Close />
          </IconButton>
        </Tooltip>
        <ForceTree data={data} />
      </div>
    );
}